module.exports = __webpack_public_path__ + "img/1.a52c2013.png";